/** @internal */
export function snakeToPascalCase(str: string): string {
    return str.replace(/^.|_+[a-z]/gi, (m) => m.replace(/_+/, '').toUpperCase())
}

/** @internal */
export function camelToSnakeCase(str: string): string {
    return str.replace(/([A-Z]+)/g, (m) => `_${m.toLowerCase()}`).replace(/^_|_$/, '')
}
